import {Card} from 'antd'
import {post_create_Api} from 'apis'
import {articleModel} from 'apis/model'
import classNames from 'classnames'
import Modal from 'components/Modal/Modal'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useContext} from 'react'
import {
    RiBarChart2Fill,
    RiImageFill,
    RiMailStarLine,
    RiQuillPenFill,
    RiRssFill,
    RiShareFill,
    RiUserAddFill,
} from 'react-icons/ri'
import useToggle from 'react-use/lib/useToggle'
import Invite from 'views/Channel/Invite'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {UseFollow} from 'views/Server/ServerContainer'
import ServerContext from 'views/Server/ServerContext'
import {useHistory} from "../../../modules/navigation/useRouter";

const gridStyle = {
    width: '100%',
    padding: '0.3em 1em',
    lineHeight: '2em',
}

export function Welcome({}) {
    const t = useTranslate()
    const {item, addNewPost, setCurrent, onJoin} = useContext(ServerContext)
    const [isToggle, toggle] = useToggle()
    const [listKey, setListKey] = useToggle()
    const {isLoading, handleAsyncAction: handleAsyncPost} = useAsyncAction({
        apiInfo: post_create_Api,
        query: {
            ':prop': item._type,
            ':id': item.id,
        },
        onSuccess: addNewPost,
        onError: notifyOnError(t),
    })

    const history = useHistory()

    return (
        <div
            className="p-3 "
            style={{
                borderRadius: '0.3em',
                width: '100%',
                overflowWrap: 'break-word',
                overflow: 'hidden',
            }}>
            <div
                style={{
                    maxWidth: '600px',
                }}
                className="flex w-full flex flex-col max-w-3xl m-auto  font-semibold text-color-300">
                <div className="text-lg text-center font-bold header mt-3 mb-6 uppercase text-color-000">
                    {t('me to the channel')}
                </div>
                <div className="flex items-center gap-8 mb-4 px-3">
                    <RiUserAddFill size={40} className="text-indigo-400" />
                    <div className="flex-1 text-color-200 font-normal">
                        <span
                            className="font-bold text-indigo-500 cursor-pointer"
                            onClick={() => {
                                !!!item.joined_status && onJoin()
                            }}>
                          {t('join')}{' '}
                        </span>
                        {t('us to share the news in this channel')}
                    </div>
                </div>
                <div className="flex items-center gap-8 mb-4 px-3">
                    <RiRssFill size={40} className="text-indigo-400"/>
                    <div className="flex-1 text-color-200 font-normal">
                        <UseFollow
                            follow_status={item.follow_status}
                            owner_id={item.id || item.username}
                            owner_type={item._type}>
                            {(handleFollow) => {
                                return (
                                    <span
                                        className="font-bold text-indigo-500 cursor-pointer"
                                        onClick={() => {
                                            !!!item.follow_status && handleFollow()
                                        }}>
                                        {t('follow')}{' '}
                                    </span>
                                )
                            }}
                        </UseFollow>
                        {t('the channel so that the system will automatically help you update with the latest news')}
                    </div>
                </div>
                <div className="flex items-center gap-8 mb-4 px-3">
                    <RiShareFill size={40} className="text-indigo-400"/>
                    <div className="flex-1 text-color-200 font-normal">
                        <span
                            className="font-bold text-indigo-500 cursor-pointer"
                            onClick={() => toggle()}>
                            {t('invite and share')}{' '}
                        </span>
                        {t('this channel to your friends')}
                    </div>
                    <Modal
                        width={620}
                        className="custom-modal"
                        destroyOnHidden
                        footer={null}
                        title={
                            <div className="text-center font-semibold text-color-000 uppercase">
                                {t('Invite your friends to this page')}
                            </div>
                        }
                        maskClosable
                        open={isToggle}
                        onCancel={() => {
                            setListKey(new Date().getTime())
                            toggle()
                        }}>
                        <Invite
                            item={item}
                            showTitle={false}
                        />
                    </Modal>
                </div>
                <div className="flex items-center gap-8 mb-4 px-3">
                    <RiMailStarLine size={40} className="text-indigo-400"/>
                    <div className="flex-1 text-color-200 font-normal">
                        <span>
                          {t('If you need assistance, please feel free to contact us via')}{' '}
                        </span>
                        <a
                            className="font-bold text-secondary"
                            href="mailto:contact@kristo.network">
                            contact@kristo.network.
                        </a>
                    </div>
                </div>
                <div className="emptyMessage-2wGhmr base-34jWEe"/>
            </div>
            {_.get(item.available_actions, 'channel_manage_post') && (
                <div
                    style={{maxWidth: '600px'}}
                    className="flex w-full flex flex-col max-w-3xl m-auto  font-semibold text-color-300">
                    <div className="text-lg text-center font-bold header mt-3 mb-6 uppercase text-color-000">
                        {t('Post something')}
                    </div>
                    <Card bordered={false} className="font-semibold">
                        <Card.Grid
                            hoverable={false}
                            className="cursor-pointer hover:text-primary rounded-t-lg"
                            onClick={() => {
                                setCurrent('createImagePost')
                            }}
                            style={gridStyle}>
                            <RiImageFill className="mr-3 text-indigo-500"/>
                            {t('image')}
                        </Card.Grid>
                        {/*<Card.Grid*/}
                        {/*  hoverable={false}*/}
                        {/*  className="cursor-pointer hover:text-primary"*/}
                        {/*  onClick={() => {*/}
                        {/*    setCurrent('quickLink')*/}
                        {/*  }}*/}
                        {/*  style={gridStyle}>*/}
                        {/*  <Icon*/}
                        {/*    className="mr-3 text-red-500"*/}
                        {/*    component={RiLinkM}*/}
                        {/*  />*/}
                        {/*  {t('link')}*/}
                        {/*</Card.Grid>*/}
                        <Card.Grid
                            hoverable={false}
                            className="cursor-pointer hover:text-primary"
                            onClick={() => {
                                setCurrent('createPoll')
                            }}
                            style={gridStyle}>
                            <RiBarChart2Fill className="mr-3 text-indigo-500"/>
                            {t('poll')}
                        </Card.Grid>
                        <PermissionContext.Consumer>
                            {({canPostArticle, ...restProps}) => {
                                return !!canPostArticle ? (
                                    <Card.Grid
                                        hoverable={false}
                                        className={classNames(
                                            'cursor-pointer hover:text-primary rounded-b-lg',
                                            !canPostArticle && 'disable'
                                        )}
                                        onClick={() => {
                                            const createArticleURL =
                                                articleModel.getLinkToCreate(item)
                                            history.push({
                                                pathname: createArticleURL,
                                            })
                                        }}
                                        style={gridStyle}>
                                        <RiQuillPenFill className="mr-3 text-indigo-500"/>
                                        {t('articles')}
                                    </Card.Grid>
                                ) : null
                            }}
                        </PermissionContext.Consumer>
                    </Card>
                    <div className="emptyMessage-2wGhmr base-34jWEe"/>
                </div>
            )}
        </div>
    )
}
